import React, {useState, useEffect, useContext} from 'react';
import {List, Tag, Button, Popconfirm, Row, Col} from 'antd';
import {Link} from 'react-router-dom';
import {DeleteOutlined} from '@ant-design/icons';

import {OpenApiContext} from '../../openapi-context';
import {AppContext} from '../../state';

export const SecuritySchemeIndex = function ({onDeleteModel, params, currentHash, filter, checkMobileView}) {
    const {dispatch} = useContext(AppContext);
    const [models, setModels] = useState([]);
    const {state} = useContext(OpenApiContext);

    function resetbreadcrumb() {
        if (checkMobileView) {
            checkMobileView();
        }
        dispatch({type: 'clear-breadcrumb'});
    }

    useEffect(() => {
        if (state.parameters) {
            setModels(state.securitySchemes(filter));
        }
    }, [currentHash, filter, state.parameters]);

    function deleteModel(model) {
        return function () {
            onDeleteModel(model);
        };
    }

    return (
        <List
            itemLayout="horizontal"
            size="small"
            dataSource={models}
            renderItem={(model) => {
                return (
                    <List.Item key={model.key} style={{width: '100%'}}>
                        <List.Item.Meta
                            avatar={<Tag color="orange">security</Tag>}
                            title={
                                <Row className="hoverable">
                                    <Col xs={22}>
                                        <Link
                                            disabled={state.editMode}
                                            onClick={resetbreadcrumb}
                                            to={`/${params.env}/standards/${params.category}/${params.key}/${params.version}/securitySchemes/${model.key}`}>
                                            {model.name}
                                        </Link>
                                    </Col>
                                    <Col xs={2}>
                                        <Popconfirm okType="default" title={`Delete security scheme ${model.name} ?`} onConfirm={deleteModel(model)}>
                                            <Button className="deleteIcon" type="link" danger size="small" icon={<DeleteOutlined />} />
                                        </Popconfirm>
                                    </Col>
                                </Row>
                            }
                        />
                    </List.Item>
                );
            }}
        />
    );
};
